// assets/cart-compare-total.js
(function () {
  console.log("[CompareTotal] Script loaded");

  var lastCart = null;
  var productCache = {};

function formatMoney(cents) {
  let formatted;

  try {
    if (
      typeof themeCurrency !== "undefined" &&
      themeCurrency.formatMoney &&
      window.theme &&
      theme.moneyFormat
    ) {
      // Use the theme’s own formatter first
      formatted = themeCurrency.formatMoney(cents, theme.moneyFormat);
    } else {
      // Fallback: basic 2–decimal string
      formatted = (cents / 100).toFixed(2);
    }
  } catch (e) {
    console.warn("[CompareTotal] formatMoney error, using fallback", e);
    formatted = (cents / 100).toFixed(2);
  }

  // 🔥 Force comma decimal if we only have a dot
  // e.g. "135.00" -> "135,00"
  formatted = formatted.replace(/(\d+)\.(\d{2})(?!\d)/, "$1,$2");

  return formatted;
}


  // Fetch product JSON once per handle (cached)
  function getProductByHandle(handle) {
    if (!handle) return Promise.resolve(null);

    if (productCache[handle]) {
      return productCache[handle];
    }

    productCache[handle] = fetch("/products/" + handle + ".js")
      .then(function (res) {
        if (!res.ok) throw new Error("product.js failed");
        return res.json();
      })
      .catch(function (err) {
        return null;
      });

    return productCache[handle];
  }

  // Compute totals using compare_at_price from product JSON (marketing compare)
  function computeTotals(cart) {
    if (!cart || !cart.items || !cart.items.length) {
      return Promise.resolve({
        total_current: 0,
        total_compare: 0,
        has_any_compare: false,
      });
    }

    var total_current = 0;
    var total_compare = 0;
    var has_any_compare = false;

   var promises = cart.items.map(function (item, index) {
  var qty = item.quantity || 1;

  var line_current =
    typeof item.final_line_price === "number" && item.final_line_price > 0
      ? item.final_line_price
      : typeof item.line_price === "number"
      ? item.line_price
      : 0;

  total_current += line_current; // for gifts this stays 0 ✅

  var handle = item.handle;
  var variantId = Number(item.variant_id || item.id);

  return getProductByHandle(handle).then(function (product) {
    var line_compare = line_current;

    if (product && product.variants && product.variants.length) {
      var matchedVariant = null;

      for (var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i];
        if (Number(v.id) === variantId) {
          matchedVariant = v;
          break;
        }
      }

      if (matchedVariant) {
        var unitPrice = Number(matchedVariant.price || 0); // cents
        var unitCompare = Number(matchedVariant.compare_at_price || 0); // cents

        console.log("[CompareTotal] Item #" + index + " variant match:", {
          title: item.title,
          variant_id: variantId,
          unitPrice: unitPrice,
          unitCompare: unitCompare,
        });

        // 🔥 even for gifts: if compare_at_price > price, use it
        if (unitCompare > unitPrice && unitCompare > 0) {
          line_compare = unitCompare * qty;
          has_any_compare = true;
        }
      }
    }

    total_compare += line_compare;
  });
    });

    return Promise.all(promises).then(function () {
      return {
        total_current: total_current,
        total_compare: total_compare,
        has_any_compare: has_any_compare,
      };
    });
  }

  function updateCompareTotal(cart) {
  if (!cart || !cart.items || !cart.items.length) {
    var wEmpty = document.querySelector("[data-cart-total-wrapper]");
    if (!wEmpty) return;
    var cmpEmpty = wEmpty.querySelector(".drawer__total-compare");
    if (cmpEmpty) {
      cmpEmpty.style.display = "none";
    }
    return;
  }

  var wrapper = document.querySelector("[data-cart-total-wrapper]");
  if (!wrapper) return;
  var compareEl = wrapper.querySelector(".drawer__total-compare");
  if (!compareEl) return;

  // 🔹 Get same currency prefix as the main total
  var prefix = "";
  var finalEl = wrapper.querySelector("[data-cart-final]");
  if (finalEl) {
    var txt = finalEl.textContent.trim();
    var m = txt.match(/^([^\d]+)/); // everything before first digit
    if (m && m[1].trim()) {
      prefix = m[1].trim() + " ";
    }
  }

  // 1️⃣ FAST APPROX: use cart-level original_total_price first
  if (
    typeof cart.original_total_price === "number" &&
    typeof cart.total_price === "number" &&
    cart.original_total_price > cart.total_price
  ) {
    var quickFormatted = formatMoney(cart.original_total_price);
    compareEl.style.display = "inline-block";
    compareEl.textContent = prefix + quickFormatted;
  } else {
    // no discount at all → hide for now
    compareEl.style.display = "none";
  }

  // 2️⃣ PRECISE VALUE: override once product JSON & compare_at_price are ready
  computeTotals(cart).then(function (res) {
    if (!res.has_any_compare || res.total_compare <= res.total_current) {
      compareEl.style.display = "none";
      return;
    }

    var formatted = formatMoney(res.total_compare);
    compareEl.style.display = "inline-block";
    compareEl.textContent = prefix + formatted;
  });
}

  function handleCartChange(cart) {
    lastCart = cart || lastCart;
    if (!lastCart) return;
    updateCompareTotal(lastCart);
  }

  function initCompareTotal() {
    console.log("[CompareTotal] initCompareTotal");

    document.addEventListener("theme:cart:change", function (event) {
      var detail = event.detail || {};
      if (detail.cart) {
        handleCartChange(detail.cart);
      }
    });

    document.addEventListener("theme:cart:reload", function () {
      if (lastCart) {
        updateCompareTotal(lastCart);
      }
    });

    // Initial load
    fetch("/cart.js", { credentials: "same-origin" })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        handleCartChange(cart);
      })
      .catch(function (err) {
      });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initCompareTotal);
  } else {
    initCompareTotal();
  }
})();
